import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { ExportAsService, ExportAsConfig } from 'ngx-export-as';

import { BaseService } from '../../base.service';
import { ConfigService } from '../../config.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {
  @ViewChild('myDiv', { static: false }) myDiv: ElementRef<HTMLElement>;

  searchTextInvoice: any = "";
  searchTextDC: any = "";

  bsValue = new Date();

  paymentObject: any = {
    payment_date: new Date()
  };



  exportInvoiceConfig: ExportAsConfig = {
    type: 'xlsx', // the type you want to download
    elementId: 'Invoice_Table', // the id of html/table element,
    options: { // html-docx-js document options
      orientation: 'landscape',
      margins: {
        top: '20'
      }
    }
  };


  exportDCConfig: ExportAsConfig = {
    type: 'xlsx', // the type you want to download
    elementId: 'DC_Table', // the id of html/table element,
    options: { // html-docx-js document options
      orientation: 'landscape',
      margins: {
        top: '20'
      }
    }
  };



  isInvoice: boolean = true;

  SelectDateRanger: any[] = [];

  p: number = 1;

  p_dc: number = 1;

  itemPerPage: any = 10;



  constructor(public exportAsService: ExportAsService, public _baseService: BaseService, public _config: ConfigService
  ) {


  }

  ngOnInit() {

    this._baseService.getAllOrders();

  }


  initializeForm() {
    this.paymentObject = {
      payment_date: new Date()
    };
  }


  triggerFalseClick() {
    let el: HTMLElement = this.myDiv.nativeElement;
    el.click();
  }

  viewInvoice(selectedItem: any) {

    this._baseService.InvoiceData = selectedItem;
    this._baseService.redirectTo('invoice-preview');
  }

  editInvoice(selectedItem: any) {

    this._baseService.InvoiceData = selectedItem;
    this._baseService.redirectTo('change-order');
  }


  setPayment(selectedItem: any) {

    this._baseService.InvoiceData = selectedItem;

    this.paymentObject.invoice_no = this._baseService.InvoiceData.invoice_no;
    this.paymentObject.id = this._baseService.InvoiceData.id;
    this.paymentObject.invoice_amount = this._baseService.InvoiceData.totalObject.GrandTotal;
    this.paymentObject.pending_amount = this._baseService.InvoiceData.balance ? this._baseService.InvoiceData.balance : this.paymentObject.invoice_amount;


    this.paymentObject.invoice_amount = this.paymentObject.invoice_amount.toFixed(2);
    this.paymentObject.pending_amount = this.paymentObject.pending_amount.toFixed(2);



  }



  amountChanged(amount: any) {

    let balance_Amount = Number(this.paymentObject.pending_amount) - Number(amount);

    this.paymentObject.balance = balance_Amount.toFixed(2);

  }



  savePayment() {

    let postBody: any = this.paymentObject;

    postBody.isUpdateOrder = true;

    let requestURL = this._config.baseURL + this._config.updateOrder;
    let headerOption = this._baseService.commonheader();

    this._baseService.doPUT(requestURL, postBody, headerOption).subscribe((results: any) => {

      if (results.data)
        this._baseService.showSuccess(results.message);
      else
        this._baseService.showError(results.message);


      this._baseService.getAllOrders();

      this.triggerFalseClick();
      this.initializeForm();

    });



  }



  exportInvoice() {
    // download the file using old school javascript method
    this.exportAsService.save(this.exportInvoiceConfig, 'Exported_Invoice').subscribe(() => {
      // save started
    });

  }

  exportDC() {
    // download the file using old school javascript method
    this.exportAsService.save(this.exportDCConfig, 'Exported_DC').subscribe(() => {
      // save started
    });

  }




}
